<template>
  <div
    v-click-outside="() => hideMenu()"
    class="profile"
  >
    <div class="profile__person">
      <div class="name-and-role">
        <span class="name">{{ $auth.remember() }}</span>
        <span class="role wrap">
          <span
            v-if="apiSystemSettings?.enableUserLevels == '1' && isUsRole == 'user'"
            class="user-level"
          >
            <AuTooltip
              v-if="enableUserStatus"
              type="slot"
              :description="textTooltip"
            >
              <span>{{ level }}&nbsp;</span>
              <span>{{ role }}</span> <span>{{ isSaleLeader }}</span>
            </AuTooltip>
            <span v-else>{{ role }}</span> <span>{{ isSaleLeader }}</span>
          </span>
          <span
            v-else
            class="user-level"
          >{{ role }}
          </span> <span>{{ isSaleLeader }}</span>
        </span>
      </div>
      <AuIcon
        icon="profile"
        :clickable="true"
        @click="toggleMenu"
      />
    </div>

    <ProfileMenu
      v-if="profileMenu"
      class="menu"
      @click="hideMenu"
    />

    <AuIcon
      class="profile__person-photo profile__person-mini"
      icon="profile"
      :clickable="true"
      @click="toggleMenu"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import isUserRole from "@/help/isUserRole";
import MetaMask from "@/mixins/MetaMask";
import ProfileMenu from "./ProfileMenu";

export default {
  components: {
    ProfileMenu
  },

  mixins: [MetaMask],

  data() {
    return {
      profileMenu: false
    };
  },

  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme",
      unviewedMessageCount: "message/unviewedMessageCount",
      profile: "profile/profile",
      apiSystemSettings: "apiSystemSettings",
      isChatVisible: "isChatVisible"
    }),

    enableUserStatus() {
      return process.env.VUE_APP_ENABLE_USER_STATUSES == "true";
    },

    textTooltip() {
      return `${this.$t("profileMenu.status")} ${this.level}<br>${this.$t("profileMenu.points")} ${this.points}`;
    },

    level() {
      return this.profile?.level.charAt(0).toUpperCase() + this.profile?.level.slice(1);
    },

    points() {
      return this.profile?.points;
    },

    isSaleLeader() {
      return this.profile?.isSaleLeader ? `${this.$t("profileMenu.leader")}` : "";
    },

    role() {
      switch (isUserRole()) {
        case "expert":
          return this.$t("profileMenu.expert");
        case "issuer":
          return this.$t("profileMenu.issuer");
        case "user":
          return process.env.VUE_APP_PLATFORM + " Member";
        default:
          return "Indefinite role";
      }
    },
    isUsRole() {
      return isUserRole();
    }
  },

  async mounted() {
    await this.getUnviewedMessageCount();
  },

  methods: {
    ...mapActions({
      getUnviewedMessageCount: "message/getUnviewedMessageCount",
      setChatVisible: "setChatVisible"
    }),

    toggleMenu() {
      this.profileMenu = !this.profileMenu;
    },

    hideMenu() {
      this.profileMenu = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.theme-switcher {
  margin-right: 24px;
}

.profile {
  display: flex;
  align-items: center;

  &__person {
    display: flex;
    align-items: center;
    gap: 10px;

    &-photo {
      width: 40px;
      height: 40px;

      cursor: pointer;

      border-radius: 15px;
    }

    @media screen and (max-width: 640px) {
      display: none;
    }

    &-mini {
      display: none;
      @media screen and (max-width: 640px) {
        display: block;
      }
    }
  }
}

.menu {
  position: fixed;
  top: 80px;
  right: 30px;
}
.name-and-role {
  display: flex;
  flex-direction: column;
  align-items: end;

  .name {
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    line-height: 0.8;
  }
  .role {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 450;
    color: var(--color-50);
  }
  .wrap {
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .user-level {
    text-transform: capitalize;
    margin-right: 2px;
  }
}
</style>
